import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { getAuth, signOut } from 'firebase/auth';
import { useHistory } from 'react-router-dom';
import { setUserInfo } from '@store/slices/authentication';
import { setCustomerInitialState } from '@store/slices/customer';
import { resetOrder } from '@store/slices/order';
import { setProductInitialState } from '@store/slices/product';
import { setProductsInitialState } from '@store/slices/products';
import { setUserInitalState } from '@store/slices/users';

const SignOut = () => {
  const dispatch = useDispatch();
  const auth = getAuth();
  const history = useHistory();

  useEffect(() => {
    const initSignOut = async () => {
      try {
        await signOut(auth);
        dispatch(setUserInfo(undefined));
        dispatch(setCustomerInitialState());
        dispatch(resetOrder());
        dispatch(setProductInitialState());
        dispatch(setProductsInitialState());
        dispatch(setUserInitalState());
        localStorage.clear();
        history.push('/login');
      } catch (err) {
        console.log(err);
      }
    };

    initSignOut();
  }, [auth, dispatch, history]);

  return <></>;
};

export default SignOut;
